export const LOGO_URL = "https://customer-assets.emergentagent.com/job_homestay-mvp/artifacts/ntqqyw65_Black%20and%20Beige%20Minimalist%20Elegant%20Cosmetics%20Logo%20%28416%20x%20227%20px%29%20%281%29.png";

export const Logo = ({ h = 40, tag, className = "" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`}>
    <img src={LOGO_URL} alt="Atiti" style={{ height: h }} className="object-contain" />
    {tag && <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#EEF2FF] text-[#4F46E5] border border-[#C7D2FE]">{tag}</span>}
  </span>
);
